import React from 'react';
import { Modal } from 'react-bootstrap';
import RoundButton from '../../common/RoundButton';
import Bell_Ic from '../../../assets/icon/Bell_ic.svg'
import { PARTNER_CHALLENGES, SCHOOL_CHALLENGES } from '../../../constants/routes.constants';
import { useAuth } from '../../auth/Auth';
import { useHistory } from 'react-router-dom';
import avatar from '../../../assets/images/Avatar.svg';
import closeicon from '../../../assets/icon/not-included.png';

const PartnerUnverifiedModal = ({ showModal, setShowModal }) => {
    const history = useHistory();
    const { school, partner } = useAuth();
    const user = school ? school : partner;
    const closeModal = () => {
        setShowModal(false)
        history.push(school ? SCHOOL_CHALLENGES : PARTNER_CHALLENGES)
    }

    return (
        <Modal className='partner-unverified-modal' show={showModal} onHide={closeModal}>
            <Modal.Header>
                <div class="close-button" onClick={closeModal}> <img src={closeicon} alt="" /></div>
            </Modal.Header>
            <Modal.Body>
                <div className='partner-unverified-inner'>
                    <div className="partner-unverified-avatar">
                        <div className="partner-unverified-avatar-wrapper">
                            <img src={user.picture_url ? user.picture_url : avatar} alt="" />
                        </div>
                        <div className="unverified-badge"><img src={Bell_Ic} alt="" /> Unverified</div>
                    </div>
                    <h4>You are not verified</h4>
                    <p>Taletree now assess your challenge and get<br /> back to you before making it public.</p>
                    <RoundButton
                        type="button"
                        label="Send"
                        className="gred-btn mt-40 mb-4 w-50 change-password-button font-weight-semibold verify-now-btn"
                        onClick={() => history.push(school ? SCHOOL_CHALLENGES : PARTNER_CHALLENGES)}
                    />
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default PartnerUnverifiedModal;